<template>
  <div class="background-image min-h-100">
    <div class="container image-border-bottom container-survey sticky-header border border-1 shadow rounded-bottom bg-white min-h-50px px-10 py-3 d-flex align-items-center justify-content-between z-index-3">
      <a class="">
        <Img alt="Logo" filename="logo.png" class="h-30px"/>
      </a>
    </div>
    <div class="container container-survey form-field py-10 h-100">

      <div v-if="loadingPage" class="loader-overlay">
        <div class="loader"></div>
      </div>

      <div v-if="getQvctSurveyForResponse">
        <div class="card shadow-sm mb-7">
          <div class="card-body">
            <div v-if="getQvctSurveyForResponse.name" class="h1 fs-2x text-center mb-5">{{ getQvctSurveyForResponse.name }}</div>

            <div class="d-flex align-items-center justify-content-center mb-5">
              <div class="h4 fs-2 text-center">
                📅 <span class="text-danger">{{ formatDate(getQvctSurveyForResponse.start_date) }}</span>
              </div>

              <div class="h4 fs-2 mx-2 text-center" v-if="getQvctSurveyForResponse.end_date">au</div>

              <div v-if="getQvctSurveyForResponse.end_date" class="h4 fs-2 text-center">
                <span class="text-danger">{{ formatDate(getQvctSurveyForResponse.end_date) }}</span>
              </div>

              <div class="h4 fs-2 ms-2 text-center">📅</div>
            </div>

            <div v-if="isHtml" v-html="getQvctSurveyForResponse.description" class="">
            </div>

            <div v-else style="white-space: pre-wrap;" class="fw-bold fs-4">
              {{ getQvctSurveyForResponse.description }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="!getQvctSurveyForResponse && !loadingPage" class="card shadow-sm mb-7">
        <div class="card-body">
          <section style="padding: 2rem; border-radius: 8px; font-family: Arial, sans-serif;">
            <h2 class="mb-5 text-center text-danger fs-2x">❌ Identifiant de l'enquête invalide</h2>
            <p class="fw-bold fs-2">
              L'identifiant que vous avez saisi ne correspond à aucun formulaire actif ou autorisé.
            </p>
            <ul class="mb-5 ms-4">
              <li class="fw-bold fs-3">Vérifiez que l’ID ne contient pas d’erreur de frappe.</li>
            </ul>
            <p class="fw-bold fs-3">
              Si vous pensez qu’il s’agit d’une erreur ou si vous n’avez pas reçu votre identifiant, merci de nous contacter<br>
            </p>
          </section>
        </div>
      </div>
    </div>
    <div class="container image-border-top container-survey sticky-footer border border-1 rounded-top bg-white min-h-50px px-10 py-3 d-flex align-items-center justify-content-between z-index-3">
      <p class="powered-by m-0 p-0 fs-5">
        Powered by <a href="https://netbyus.com" target="_blank" rel="NetByUs" title="NetByUs">NetByUs</a>
      </p>

      <div class="d-flex">
        <router-link v-if="getQvctSurveyForResponse" tag="a" class="btn btn-primary rounded-sm" :to="{name: 'qvct-survey-preview-viewform', params: {id: route.params.id}}">
          <i class="fa fa-arrow-right fs-3"></i>
          Commencer
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import Img from "@/components/Img.vue"
import {computed, onMounted, ref} from "vue"
import {useStore} from "vuex"
import {useRoute} from "vue-router"
import {formatDate} from '@/mixins/Helpers'

const store = useStore()
const route = useRoute()

const loadingPage = ref(false)

const getQvctSurveyForResponse = computed(() => store.getters['qvctSurvey/getQvctSurveyForResponse'])
const isHtml = computed(() => /<\/?[a-z][\s\S]*>/i.test(getQvctSurveyForResponse.value?.description))

onMounted(async () => {
  loadingPage.value = true
  if(route.params.id) {
    store.dispatch('qvctSurvey/loadQvctSurveyForResponse', {
      id: route.params.id,
      mustBeActive:false
    })
        .then(() => {
          loadingPage.value = false
        })
        .catch(() => {
          loadingPage.value = false
        })
  }
})
</script>
<style scoped>
.background-image {
  background:
      linear-gradient(rgba(0, 114, 206, 0.1), rgba(240, 120, 23, 0.1)),
      url('../../../../../public/assets/media/empty_bg.png') no-repeat center center,
      url('../../../../../public/assets/media/empty_bg.png') no-repeat center center;
  background-size: cover, cover, cover;
  width: 100%;
}

.image-border-bottom {
  border-bottom: 13px solid transparent !important;
  border-image: url('../../../../../public/assets/media/qvct_servey-banner.png') 30 round !important;
  border-image-slice: 0 0 56 0 !important;
  border-image-width: 0 0 13px 0 !important;
  border-image-outset: 0 !important;
}

.image-border-top {
  border-top: 13px solid transparent !important;
  border-image: url('../../../../../public/assets/media/qvct_servey-banner.png') 30 round !important;
  border-image-slice: 56 0 0 0 !important;
  border-image-width: 13px 0 0 0 !important;
  border-image-outset: 0 !important;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1030;
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  z-index: 1030;
}

.container-survey {
  margin: auto;
  max-width: 90vw;
  width: 640px;
}

.powered-by a {
  color: #007BFF;
  text-decoration: none;
  font-weight: 500;
}

.powered-by a:hover {
  text-decoration: underline;
}

.form-field {
  min-height: 100vh !important;
}

.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.loader {
  width: 40px;
  height: 40px;
  border: 5px solid #ccc;
  border-top-color: #007BFF;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

</style>